import Loader from '../loader/Loader.tsx';
import { lazy, Suspense } from 'react';
import ErrorBoundary from '../ErrorBoundary.tsx';

const AcceptedTerms = lazy(() => import('./AcceptedTerms.tsx'));
const AcceptedTermsMobile = lazy(() => import('./AcceptedTermsMobile.tsx'));

const TermsWrapper = () => {
  return (
    <ErrorBoundary fallbackComponent={AcceptedTermsMobile}>
      <Suspense fallback={<Loader />}>
        <AcceptedTerms />
      </Suspense>
    </ErrorBoundary>
  );
};

export default TermsWrapper;
